import { Account } from "../domain";
import { receiveMoney } from "./receiveMoney";
import { sendMoney } from "./sendMoney";

export function moveMoney(amount: number, from: Account, to: Account, description: string): Promise<any[]> {
  return sendMoney(amount, from, to.name, description)
    .then(() => receiveMoney(amount, from.name, to, description));
}